import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { ToasterContainerComponent } from './shared/components/toaster/toaster.component';
import { LanguageService } from './core/services/language.service';

@Component({
  selector: 'app-root',
  template: `
    <app-toaster-container />
    <app-loader />
    <router-outlet />
  `,
  imports: [RouterOutlet, LoaderComponent, ToasterContainerComponent],
})
export class AppComponent implements OnInit {
  title = 'HFS Courrier';

  readonly #destroyRef: DestroyRef = inject(DestroyRef);
  readonly #activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  readonly #router = inject(Router);
  readonly #titleService = inject(Title);
  readonly #languageService = inject(LanguageService);

  constructor() {
    this.#titleService.setTitle(this.title);
    // Initialize language service (auto-detect or load from storage)
    // This is done in the service constructor
  }

  ngOnInit(): void {
    this.#router.events.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
    });
  }
}
